export default __webpack_public_path__ + "static/media/wallpaper-Elf-04.e06087cf.png";